import { createContractClient } from './lib/api-client';
import { organizationRoutes } from '@contracts/account/organization';

export const organizationApi = createContractClient(organizationRoutes);
